import { environment } from '../../../environments/environment';
import { GATEWAY_API_BASE_URL } from '../api/mhsGatewayApiTokens';

export function provideGatewayApiBaseUrl() {
  return {
    provide: GATEWAY_API_BASE_URL,
    useValue: environment.gatewayUrl
  };
}